import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { authGroupGuard } from './core/guards/auth-group.guard';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
    },
    {
        path: 'unauthenticated',
        loadComponent: () =>
            import('./pages/unauthenticated/unauthenticated.component').then((m) => m.UnauthenticatedPage),
    },
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./pages/unauthorized/unauthorized.component').then((m) => m.UnauthorizedPage),
        canActivate: [MsalGuard],
    },
    {
        path: 'home',
        loadChildren: () =>
            import('./pages/users/users.routes').then((m) => m.usersRoutes),
        canActivate: [MsalGuard, authGroupGuard],
    },
    {
        path: '**',
        loadComponent: () =>
            import('./pages/not-found/not-found.component').then((m) => m.NotFoundPage),
        canActivate: [MsalGuard, authGroupGuard],
    }
];
